import React from 'react'
import Footer from '../Footer'
import EduOne from '../EduOne'

function ImgthsOne() {
    window.scrollTo(0,0);
    return (
        <div>
            <EduOne/>
            <Footer/>
        </div>
    )
}

export default ImgthsOne
